
	import LoadingComponent from "custom/LoadingComponent"
	import Component from "vue-class-component"

	import PButton from "@portal-components/ui/input/PButton.vue"
	import PTextInput from "@portal-components/ui/input/PTextInput.vue"

	import PValidationErrors from "@portal-components/ui/input/PValidationErrors.vue"
	import toaster from "@portal-components/ui/utils/toaster"

	import { StoreAction } from "@lib/types/vuex"
	import validate from "store/user/rules"
	import { Watch } from "vue-property-decorator"
	import { ObjectErrors } from "lib/types/validation"
	import { userModule } from "store/modules"
	import { User } from "store/user/types"
	import localStorageClient from "api/clients/local-storage-client"
	
	@Component({
		components: {
			PTextInput,
			PButton,
			PValidationErrors
		}
	})
	export default class MyDetails extends LoadingComponent {
		@userModule.Getter user!: User
		@userModule.Action updateCurrentUser!: StoreAction<User>

		readonly baseTranslationKey = "profile.myDetails"

		userDetails: User = {}
		errors?: ObjectErrors<User> = {}
		checkImpersonate = localStorageClient.getItem("CHECK_IMPERSONATE")

		async submit(): Promise<void> {
			try {
				await this.manageLoadingState(this.updateCurrentUser(this.userDetails))
				toaster.success({ title: `${ this.baseTranslationKey }.success` })
			} catch (error) {
				toaster.error({ title: `${ this.baseTranslationKey }.error` })
			}
		}

		isDirty(value: any): boolean {
			return value !== undefined
		}

		isCheckImpersonate(value: any): boolean {
			if(value === "1") {
				return true
			} else {
				return false
			}
		}
		
		@Watch("user")
		userChanged(): void {
			this.userDetails = { ...this.user }
		}

		@Watch("userDetails", { immediate: true, deep: true })
		async userDetailsChanged(user: User): Promise<void> {
			this.errors = await validate(user, undefined)
		}
	}
